<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Insturment Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="instrument.name">
      <template #right-content>
        <header-button-group :button_config="button_config">
          <template #post_buttons>
            <button
              v-show="checkPermission('delete insturment')"
              title="Delete insturment"
              class="btn btn-danger ml-1"
              @click="showDeleteModal"
            >
              <i class="fal fa-trash" />
            </button>
          </template>
        </header-button-group>
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'read instrument'">
      <template #gated-content>
        <instrument-card v-if="instrument_id" :instrument="instrument" />
        <instrument-detail-cardstack :instrument="instrument" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import InstrumentCard from "@/components/lab/instrument/InstrumentCard";
import InstrumentDetailCardstack from "@/components/lab/instrument/InstrumentDetailCardstack";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { AccessControlCheck } from "@/auth/AccessControlCheck";
import { notificationOptions } from "@/shared/toast-notification-options";
import { instrumentNotifications } from "@/shared/notifications";
import { getModel } from "@/shared/fetch-utils";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";

Vue.use(VueNotifications, notificationOptions);

const InstrumentRepository = LabRepositoryFactory.get("instrument");

export default {
  name: "InstrumentDetail",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    InstrumentCard,
    InstrumentDetailCardstack,
    PermissionAlertGate,
  },
  mixins: [ToastNotifications],
  data() {
    return {
      loading: true,
      instrument_id: this.$route.params.instrument_id || null,
      instrument: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-search",
            linkto: `/instrument/${this.instrument_id}/audit-trail`,
            title: "Back to Audit Trail",
            variant: "dark",
          },
          {
            icon: "fa-list",
            linkto: "/instrument",
            title: "Instrument list",
          },
          {
            icon: "fa-pencil",
            linkto: `/instrument/${this.instrument_id}/edit`,
            title: "Edit instrument",
            variant: "warning",
            permission: this.checkPermission("edit instrument"),
          },
        ],
      };
    },
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
    showDeleteModal() {
      this.$bvModal
        .msgBoxConfirm(
          "You are about to remove this instrument. Do you want to continue?",
          {
            title: "Are you sure?",
            modalClass: ["modal-danger"],
            size: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            centered: true,
          }
        )
        .then(async (confirm) => {
          if (confirm) {
            try {
              await InstrumentRepository.suspend(this.instrument_id);

              this.deleteSuccess();
              this.$router.push("/instrument");
            } catch ({ response }) {
              const { status, data } = response.response;

              this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
                title: "Server Error.",
                variant: "danger",
              });
            }
          }
        });
    },
  },
  async created() {
    this.loading = true;

    this.instrument = await getModel({
      model_type: "instrument",
      id: this.instrument_id,
      message: this.$bvToast,
    });

    this.instrument ? (this.loading = false) : this.$router.back();
  },
  notifications: instrumentNotifications,
};
</script>
